import React from "react"
import { Window, DataTable, Text, View, Animator } from "react-ame-components"
import ShowCase from "../components/Showcase"
import HarryPotter from "../assets/json/harryPotter.json"
import lottieAnimation from "../assets/lottie/playing.json"

export class DataTableExample extends React.Component {
  state = {
    progressPending: true,
    columns: [
      {
        name: "Nome",
        selector: row => row.name,
      },
      {
        name: "Patrono",
        selector: row => row.patronus,
      },
      {
        name: "Ancestralidade",
        selector: row => row.ancestry,
      },
      {
        name: "Casa",
        selector: row => row.house,
      },
      {
        name: "Ano de nascimento",
        selector: row => row.yearOfBirth,
      },
    ],
    data: [],
  }
  componentDidMount() {
    setTimeout(
      () => this.setState({ progressPending: false, data: HarryPotter }),
      3000,
    )
  }

  render() {
    return (
      <Window>
        <ShowCase
          title="Componente DataTable"
          description="Componente DataTable para visualização de dados em colunas e linhas">
          <View
            borderColor="neutral-500"
            borderWidth="hairline"
            borderRadius="small"
            marginTop="large"
            padding="nano">
            <DataTable
              data={this.state.data}
              columns={this.state.columns}
              pagination
              progressPending={this.state.progressPending}
              progressComponent={
                <View
                  padding="large"
                  direction="column"
                  align="center"
                  justify="center">
                  <Animator animationData={lottieAnimation} />
                  <Text
                    textAlign="center"
                    color="background-color">
                    Carregando...
                  </Text>
                </View>
              }
            />
          </View>
        </ShowCase>
      </Window>
    )
  }
}
